import { RollingSadFace } from '@/components/atoms/animatedFaces'
import { BorderedButton } from '@/components/atoms/button'
import { Box } from '@/components/atoms/Grid'
import ContentPlaceholder from '@/components/molecules/contentPlaceholder'
import { useActiveFilterDispatch } from '@/providers/filterProvider/filtersProvider'
import useTranslation from 'next-translate/useTranslation'
import { useAsset } from '@/providers/assetsProvider'
import { SadDogSmileFace } from '@/components/atoms/dogsSmileFace'
import { FC } from 'react'

const ProductsListingContentPlaceholder: FC = () => {
  const { discardAllFilter } = useActiveFilterDispatch()
  const { t } = useTranslation('common')
  const { isCountryForDogSmileFace } = useAsset()

  return (
    <Box textAlign="center">
      <ContentPlaceholder
        mx={10}
        mt={20}
        mb={20}
        IllustrationElement={
          isCountryForDogSmileFace ? <SadDogSmileFace /> : <RollingSadFace />
        }
        title={t('Products.ContentPlaceholder.title')}
        text={t('Products.ContentPlaceholder.text')}
      />

      <BorderedButton
        mb={50}
        title={t('Products.ContentPlaceholder.clearFilter')}
        onClick={() => discardAllFilter()}
      />
    </Box>
  )
}

export default ProductsListingContentPlaceholder
